import React from 'react';
import { motion } from 'framer-motion';

interface FloatingWordsProps {
  words: { text: string; className: string }[];
}

const FloatingWords: React.FC<FloatingWordsProps> = ({ words }) => {
  return (
    <span className="inline-flex items-baseline gap-x-4 md:gap-x-6 flex-wrap justify-center">
      {words.map((word, i) => (
        <motion.span
          key={i}
          className={word.className + ' inline-block will-change-transform'}
          initial={{ opacity: 0, y: 40, x: -20, filter: 'blur(8px)' }}
          animate={{
            opacity: [0, 1, 1, 0.85, 1],
            y: [40, 0, -14, 0, -10],
            x: [-20, 0, 12, 0, -8],
            filter: ['blur(8px)', 'blur(0px)', 'blur(0px)', 'blur(0px)', 'blur(0px)'],
          }}
          transition={{
            duration: 6,
            delay: i * 0.8,
            repeat: Infinity,
            repeatType: 'mirror',
            ease: 'easeInOut',
            times: [0, 0.15, 0.45, 0.7, 1],
          }}
        >
          {word.text}
        </motion.span>
      ))}
    </span>
  );
};

export default FloatingWords;
